import React from 'react';
import { func, object, shape } from 'prop-types';
import classNames from 'classnames';

import { isBusinessProfile } from '../../../util/profileSeoUrl';

import css from './OwnStockToggle.module.css';

/**
 * "Visa mitt lager (inkl. inbyten)" on /annonser (P25009-485 BR-4).
 *
 * For a signed-in business only: switches the search to the workshop's own
 * stock — hidden trade-ins included — while keeping every other filter,
 * the plate search too. "Endast inbyten" narrows that to trade-ins.
 *
 * Both are URL parameters (`searchType=ownListing`, `inbyte=1`), the same
 * own-listing mode the "(Du)" seller pill uses. Whose stock is shown is never
 * in the URL: SearchPage.duck takes the author from the session.
 */
const OwnStockToggle = ({ currentUser, history }) => {
  if (!currentUser || !isBusinessProfile(currentUser)) return null;

  const params =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search)
      : new URLSearchParams('');
  const ownStock = params.get('searchType') === 'ownListing';
  const tradeinOnly = ownStock && params.get('inbyte') === '1';

  const go = () => {
    params.set('page', '1');
    history.push(`?${params.toString()}`);
  };

  const toggleOwnStock = () => {
    if (ownStock) {
      params.delete('searchType');
      params.delete('inbyte');
      params.delete('stock');
    } else {
      params.set('searchType', 'ownListing');
      params.delete('selectedUserId');
    }
    go();
  };

  const toggleTradeinOnly = () => {
    if (tradeinOnly) params.delete('inbyte');
    else params.set('inbyte', '1');
    go();
  };

  return (
    <div className={css.root}>
      <label className={css.toggle}>
        <input
          type="checkbox"
          className={css.checkbox}
          checked={ownStock}
          onChange={toggleOwnStock}
        />
        <span>Visa mitt lager (inkl. inbyten)</span>
      </label>
      {ownStock ? (
        <button
          type="button"
          className={classNames(css.chip, { [css.chipActive]: tradeinOnly })}
          aria-pressed={tradeinOnly}
          onClick={toggleTradeinOnly}
        >
          Endast inbyten
        </button>
      ) : null}
    </div>
  );
};

OwnStockToggle.defaultProps = { currentUser: null };

OwnStockToggle.propTypes = {
  currentUser: object,
  history: shape({ push: func.isRequired }).isRequired,
};

export default OwnStockToggle;
